"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
const variants = {
  outline: {
    field: {
      border: '1px solid',
      borderColor: 'inherit',
      bg: 'inherit',
      _hover: {
        borderColor: 'gray.300'
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
      },
      _invalid: {
        borderColor: 'error',
        boxShadow: t => `0 0 0 1px ${t.colors.error}`
      },
      _focus: {
        zIndex: 1,
        borderColor: 'primary.400',
        boxShadow: t => `0 0 0 1px ${t.colors.primary['400']}`
      }
    },
    addon: {
      border: '1px solid',
      borderColor: 'inherit',
      bg: 'gray.100'
    }
  }
};
var _default = exports.default = (0, _merge.default)(_theme.default.components.Select, {
  variants
});